module.exports = __webpack_public_path__ + "img/discovery-photo.71c72050.jpg";